/**
 * The scale component defines a shrinking, stretching, or skewing transformation of an entity.
 * It takes three scaling factors for the X, Y, and Z axes.
 *
 * All entities inherently have the scale component.
 *
 * @see https://aframe.io/docs/1.3.0/components/scale.html
 */
export var Scale = function Scale(_ref) {
  var _this = this;

  var x = _ref.x,
      y = _ref.y,
      z = _ref.z;

  this.toString = function () {
    return _this.x + " " + _this.y + " " + _this.z;
  };

  this.x = x;
  this.y = y;
  this.z = z;
};